import { CountrySelectorBootstrap } from './models/country-selector-bootstrap';

export const bootstrap: CountrySelectorBootstrap = (countrySelectorElements: JQuery) => {
  countrySelectorElements.each((index: number, countrySelectorElement: HTMLSelectElement) => {
    const countryStatesElement = document.getElementById(countrySelectorElement.getAttribute('states-json-id'));

    if (countryStatesElement === null) {
      return;
    }

    const countryStates: any[] = JSON.parse(countryStatesElement.innerHTML);
    const countryStatesElementId = countrySelectorElement.getAttribute('states-list-id');
    let lastSelectedCountry: string;
    let lastSelectedCountryIndex: number;

    countryStatesElement.parentNode.removeChild(countryStatesElement);
    const $countrySelectorElement: JQuery = $(`#${countrySelectorElement.getAttribute('id')}`);
    $countrySelectorElement.on('change', () => {
      const selectedCountry = countrySelectorElement.value;
      const countryWithStates = countryStates.filter((c: any) => c.IsoCode === selectedCountry)[0];

      if (lastSelectedCountry !== undefined) {
        countrySelectorElement.options[lastSelectedCountryIndex].value = lastSelectedCountry;
      }

      lastSelectedCountry = selectedCountry;
      lastSelectedCountryIndex = countrySelectorElement.selectedIndex;
      const countryStatesElements: JQuery = $(`#${countryStatesElementId}`);
      if (countryStatesElements.length > 0 && (countryStatesElements as any).parsley) {
        (countryStatesElements as any).parsley().destroy();
      }

      countryStatesElements.off().remove();
      if (!countryWithStates) {
        return;
      }

      const states = countryWithStates.States;
      let statesSelectorHtml = '<select id="{0}" {1} {2} class="jbr-form__input jbr-form__input--dropdown" style="margin-top: 9px;" name="{3}">'
        .replace(/\{0\}/gi, countryStatesElementId)
        .replace(/\{1\}/gi, 'required')
        .replace(/\{2\}/gi, 'data-parsley-error-message="' + countrySelectorElement.getAttribute('states-required-message') + '"')
        .replace(/\{3\}/gi, countrySelectorElement.getAttribute('name'));
      statesSelectorHtml += '<option value>' + countrySelectorElement.getAttribute('states-list-empty-option') + '</option>';
      for (const state of states) {
        statesSelectorHtml += `<option value="${selectedCountry}-${state.IsoCode}">${state.CountryStateName}</option>`;
      }

      statesSelectorHtml += '</select>';
      $countrySelectorElement.after(statesSelectorHtml);

      const $countryStatesElement = $(`#${countryStatesElementId}`);
      $countryStatesElement.on('change', () => {
        const countryStatesElementValue = $countryStatesElement.val() as string;
        if (countryStatesElementValue === '') {
          countrySelectorElement.options[countrySelectorElement.selectedIndex].value = selectedCountry;
        } else {
          countrySelectorElement.options[countrySelectorElement.selectedIndex].value = countryStatesElementValue;
        }
      });

      if (($countryStatesElement as any).parsley) {
        ($countryStatesElement as any).parsley();
      }
    });

    // Trigger change event because country list could be pre-selected from Sitecore.
    $countrySelectorElement.trigger('change');
  });
};
